import type { Prompt } from "@/services/helpers";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

export type Limits = {
  brands?: { used: number; limit: number; remaining: number };
  runs: { used: number; limit: number; remaining: number };
  prompts: { used: number; limit: number; remaining: number };
};
interface Cluster {
  title: string;
}

export interface ClusterWithPrompt {
  title: string;
  clusterId?: string;
  country?: string,
  prompts: {
    text: string;
    selected?: boolean;
    country?: string;
    isCustom?: boolean;
  }[];
}

interface DataState {
  storedLimitPrompts: Limits | null;
  setStoredLimitPrompts: (data: Limits | null) => void;
  rawData: Prompt[] | [];
  setRawData: (ata: Prompt[] | []) => void,
  competitorsApproved: number,
  setCompetitorsApproved: (data: number) => void;
  reset: () => void;
  allClusters: Cluster[],
  allSelectedClusters: number[],
  setAllSelectedClusters: (selected: number[]) => void;
  setAllCluster: (clusters: Cluster[]) => void;
}

const initialState = {
  storedLimitPrompts: null,
  rawData: [],
  allClusters: [],
  allSelectedClusters: []
};

const initialStateClusters = {
  allClusters: [],
  allSelectedClusters: []
};

const safeStorage = {
  getItem: (name: string) => {
    return localStorage.getItem(name)
  },
  setItem: (name: string, value: string) => {
    try {
      localStorage.setItem(name, value)
    } catch (e) {
      if (e instanceof DOMException && e.name === "QuotaExceededError") {
        console.warn("Storage full. Clearing app-data...")
        localStorage.removeItem(name)
        localStorage.setItem(name, value)
      } else {
        throw e
      }
    }
  },
  removeItem: (name: string) => {
    localStorage.removeItem(name)
  },
}

export const useDataStore = create<DataState>()(
  persist(
    (set) => ({
      ...initialState,
      competitorsApproved: 0,

      setStoredLimitPrompts: (data) => set({ storedLimitPrompts: data }),
      setRawData: (data) => set({ rawData: data }),
      setCompetitorsApproved: (data) => set({ competitorsApproved: data }),
      setAllCluster: (data) => set({ allClusters: data }),
      setAllSelectedClusters: (data) =>
        set({ allSelectedClusters: data }),

      reset: () => {
        set(initialStateClusters)
        localStorage.removeItem("app-data")
      },
    }),
    {
      name: "app-data",
      storage: createJSONStorage(() => safeStorage),
      partialize: (state) => ({
        competitorsApproved: state.competitorsApproved,
        storedLimitPrompts: state.storedLimitPrompts,
      }),
    }
  )
);
